import React from 'react'
import Navbar from '../../navbar/Navbar'
import Footer from '../../footer/Footer';
import CSMTabs from './CSMTabs';

function CSMLab() {
    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 pe-lg-4 order-2 order-lg-1">
                            <CSMTabs />
                        </div>
                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="how-to-apply">
                                <h2>CSM Laboratories
                                </h2>
                                <div className='pt-2 submit'>
                                    <div className='eventsImages'>
                                        <h5 className='pt-3'>
                                            List of Laboratories
                                        </h5>
                                        <table class="table table-bordered table-striped">
                                            <thead class="table-dark">
                                                <tr>
                                                    <th scope="col">S.No</th>
                                                    <th scope="col">Name of the Laboratories</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr><td>1</td><td>Introduction to Data Structures Lab (DS LAB)</td></tr>
                                                <tr><td>2</td><td>Machine Learning Lab (ML LAB)</td></tr>
                                                <tr><td>3</td><td>Computer Networks Lab (CN LAB)</td></tr>
                                                <tr><td>4</td><td>Database Management Systems Lab (DBMS LAB)</td></tr>
                                                <tr><td>5</td><td>Prolog/ Lisp/ Pyswip (PROLOG LAB)</td></tr>
                                                <tr><td>6</td><td>Natural Language Processing Lab (NLP LAB)</td></tr>
                                                <tr><td>7</td><td>Java Programming Lab (JAVA LAB)</td></tr>
                                                <tr><td>8</td><td>UI Design Flutter Lab</td></tr>
                                                <tr><td>9</td><td>Operating Systems Lab (OS LAB)</td></tr>
                                                <tr><td>10</td><td>Software Engineering Lab (SE LAB)</td></tr>
                                                <tr><td>11</td><td>Node JS</td></tr>
                                                <tr><td>12</td><td>Data Analytics Lab (DA LAB)</td></tr>
                                                <tr><td>13</td><td>Cloud Computing Lab (CC LAB)</td></tr>
                                                <tr><td>14</td><td>Data Mining Lab (DM LAB)</td></tr>
                                            </tbody>
                                        </table>

                                        <h5 className='pt-3'>

                                            CSM Lab Images
                                        </h5>
                                        <div className='row mt-4'>

                                            <div className='col-md-6 col-lg-6 mb-3 '>
                                                <img src="https://admin.swec.ac.in/assetsswec/img/csm/Lab-photo-4.jpeg" alt="Lab Photo 4" class="img-responsive center-block sixteen-nine rounded-1" loading="lazy" />
                                            </div>
                                            <div className='col-md-6 col-lg-6 mb-3 spotlight-group'>
                                                <img src="https://admin.swec.ac.in/assetsswec/img/csm/Lab-photo-1.jpeg" alt="Lab Photo 1" class="img-responsive center-block sixteen-nine rounded-1" loading="lazy" />
                                            </div>
                                            <div className='col-md-6 col-lg-6 mb-3 spotlight-group'>
                                                <img src="https://admin.swec.ac.in/assetsswec/img/csm/Lab-photo-2.jpeg" alt="Lab Photo 2" class="img-responsive center-block sixteen-nine rounded-1" loading="lazy" />
                                            </div>
                                            <div className='col-md-6 col-lg-6 mb-3 spotlight-group'>
                                                <img src="https://admin.swec.ac.in/assetsswec/img/csm/Lab-photo-3.jpeg" alt="Lab Photo 3" class="img-responsive center-block sixteen-nine rounded-1" loading="lazy" />
                                            </div>

                                        </div>
                                    </div>
                                </div>



                                <div className=''>
                                    {/* <div class="detgails-right-content mt-4">
                                        <div class="related-download bg-gray">
                                            <ul>
                                                <li>
                                                    <a href="https://admin.swec.ac.in/assetsswec/documents/csm/Csm-Syllabus-of-Minor-Degree-Program(SD-R22).pdf" target='_blank'><i class="fa-solid fa-file-pdf"></i>  Syllabus of Minor Degree Program(SD-R22)</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div> */}
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default CSMLab


